export default __webpack_public_path__ + "assets/0dbca1c6531b21b6dccdfd17df22a2ad.png";